// store
import store from './store'

const getAuth = () => {
  return store.state.auth.auth
}

const isAllowPermission = (opt) => {
  let auth = getAuth()
  let permissions = auth.user_info.permissions
  for (let i in permissions) {
    if (permissions[i].app_id == opt.app_id) {
      return true
    }
  }
  return false
}

const isInstallApp = (opt) => {
  let auth = getAuth()
  let apps = auth.shop_info.install_apps
  for (let i in apps) {
    let isInstall = apps[i].app_id == opt.app_id
    if (isInstall) {
      return true
    }
  }
  return false
}

const isVisitAble = ({ meta, permissions }) => {
  const { info, requireAction } = meta
  const { appId, moduleId, subModuleId } = info
  const permission = permissions.find((item) => item.app_id === appId)
  for (const moduleItem of permission.modules) {
    if (moduleItem.module_id !== moduleId) continue
    const hasSubModules = moduleItem.sub_modules && !!moduleItem.sub_modules.length
    if (hasSubModules) {
      for (const subModuleItem of moduleItem.sub_modules) {
        if (subModuleItem.sub_module_id !== subModuleId) continue
        return Object.keys(requireAction).every((key) => subModuleItem.action[key] === true)
      }
    } else {
      return Object.keys(requireAction).every((key) => moduleItem.action[key] === true)
    }
  }
  return false
}

export default (to, from, next) => {
  const auth = getAuth()

  if (to.meta.requireLogin) {
    if (!auth.user_info) return next({ path: '/signin' })
  }

  if (to.meta.requireLoginShop) {
    if (!auth.shop_info) return next({ path: '/company' })
  }

  if (to.meta.requireOwner) {
    if (auth.user_info.type != 'owner') return next({ path: '/desktop' })
  }

  if (to.meta.requirePermissions) {
    const permissions = auth.user_info.permissions
    for (let i in to.meta.requirePermissions) {
      const app_id = to.meta.requirePermissions[i]
      const isAllowedPermission = isAllowPermission({ app_id: app_id })
      const isInstalledApp = isInstallApp({ app_id: app_id })
      if (!isAllowedPermission) {
        return next({ path: '/desktop' })
      }
      if (!isInstalledApp) {
        return next({ path: '/desktop' })
      }
    }
  }

  if (to.meta.requireAction) {
    const permissions = auth.user_info.permissions
    const isVisitedAble = isVisitAble({ meta: to.meta, permissions })
    if (!isVisitedAble) {
      return next({ path: '/desktop' })
    }
  }

  if (auth.shop_info && auth.shop_info.is_suspended) {
    const isNotBillingPages = to.path.search('/desktop/billing') === -1
    const isNotPaymentPages = to.path.search('/desktop/payment') === -1
    const isNotHomePages = to.name !== 'Home'
    if (isNotBillingPages && isNotPaymentPages && isNotHomePages) {
      return next({ path: '/desktop/billing/invoice/all' })
    }
  }

  next()
}



// WEBPACK FOOTER //
// ./src/middleware.js